export type FieldValidatorType = (value: string | CheckBoxesData) => string | undefined
type CheckBoxesData = {
    isMJ: boolean
    isMedical: boolean
    isRecreation: boolean

}
export const symbol = (type: string): FieldValidatorType => (value) => {

    let error = undefined
    if (value && typeof value === 'string') {
        if (type === 'password') {
            value.length < 8
                ? error = 'Password is invalid'
                : error = undefined
        } else if (type === 'email') {

            if (value && value.indexOf('@') !== -1) {

                error = undefined
            } else {

                error = 'E-mail is invalid'
            }
        } else if (type === 'file') {

            error = undefined
        }

    } else {
        error = 'required'
    }
    return error
}

export const emailValidate = symbol('email')
export const passwordValidate = symbol('password')

export const checkboxesValidator : FieldValidatorType =  (value) => {
    let error = undefined


            if (!value) {
                error = 'required'
            }
   

    return error
}

export const formValidate = (values: any): FieldValidatorType => {
 

    
 
    //@ts-ignore
  
    return undefined
}


export const requiredFields: FieldValidatorType = (value) => {
    let error = undefined
    if (!value) {

        error = 'required'
    }



    return error
}




